var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicenseOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 504,
    height: 360,
    viewBox: "0 0 504 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504 360H0V0H504V360ZM80 46C71.1634 46 64 53.1634 64 62V298C64 306.837 71.1634 314 80 314H424C432.837 314 440 306.837 440 298V62C440 53.1634 432.837 46 424 46H80Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 46,
    width: 376,
    height: 268,
    rx: 15,
    stroke: "#DB9E2F",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseOverlay);
export default __webpack_public_path__ + "static/media/license_overlay.080de3d439d7438a6bb03338684bebd5.svg";
export { ForwardRef as ReactComponent };